export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Email Verification',
        step1Title: 'Help Us Keep Your Account Secure',
        step1MessageLine1: 'To enhance the security of your account, we require additional verification of your account.',
        step1MessageLine2: 'We will send a one-time passcode to your email.',
        step1MessageLine3: 'The information collected here will only be used for verification purposes. By clicking “Send”, your (1) agree to the current version of our',
        termsOfUse: 'TERMS OF USE',
        step1MessageLine3Part2: ', and (2) have read Sephora’s',
        privacyPolicy: 'Privacy Policy',
        send: 'Send Email Verification',
        infoTitle: 'Help us keep your account secure',
        infoMessage: 'This helps us ensure that only you have access to your account and protects your information from unauthorized access.',
        infoOk: 'Got it',
        step2Title: 'Check your email and enter your verification code',
        step2MessageLine1: `You will receive a code at <strong>${vars[0]}</strong> if it is registered with a Beauty Insider account.`,
        step2MessageLine2: 'Didn\'t get an email?',
        resend: 'Resend',
        step2MessageLine2Part2: 'code in',
        seconds: 'seconds',
        errorOtpIncorrect: 'The code you entered is incorrect. Please check and try again.',
        errorGenericMessage: 'We\'re unable to confirm your one time passcode at this time. Please try again later.',
        infoErrorTitle: 'Error',
        infoErrorMessage: 'Unable to send a one time passcode to your email this time. Please try again later.',
        infoErrorTooManyAttemptsTitle: 'Too Many Attempts',
        infoErrorTooManyAttemptsMessage: 'Too many attempts. Please try again later.',
        accessibilityInfoIcon: 'info icon',
        expiredOTP: 'The code you entered has expired. Please resend another code.'

    };

    return resources[label];
}
